import { CLEAR_PARAMETER, CREATE_PARAMETER, UPDATE_PARAMETER } from '../action/parameter.actions';

export function reducer() { }




// WEBPACK FOOTER //
// ./SignClient/app/statemanagement/reducer/parameter.reducer.ts